import {LANGUAGE} from "@/common/utils/constants.js";

export const COMMON_PDF = {
	[LANGUAGE.en.short]: {
		toolsAndSystems: `Tools/Systems`,
		certifications: 'Certifications',
		clientResult: 'Client Results',
		solution: 'Solution',
		services: 'Services',
		project: 'Project',
		industry: 'industry',
		clientLocation: 'client\'s locations covered',
		confidentialMessage: '* For internal purposes only. Please do not share client information outside of the organization.',
		deliveryLocation: 'project delivery locations',
		year: 'year',
		month: 'month',
		years: 'years',
		and: 'and',
		months: 'Months',
	},
	[LANGUAGE.de.short]: {
		toolsAndSystems: `Tools/Systeme`,
		certifications: 'Zertifizierungen',
		clientResult: 'Kundenergebnisse',
		solution: 'Lösung',
		services: 'Dienstleistungen',
		project: 'Projekt.',
		industry: 'Branche',
		clientLocation: 'Abgedeckte Kundenstandorte',
		confidentialMessage: '* Nur für interne Zwecke. Bitte geben Sie keine Kundeninformationen außerhalb der Organisation weiter.',
		deliveryLocation: 'Projektlieferstandorte',
		year: 'Jahr',
		month: 'Monat',
		years: 'Jahre',
		and: 'und',
		months: 'Monate',
	},
	[LANGUAGE.fr.short]: {
		toolsAndSystems: `Outils/Systèmes`,
		certifications: 'Certifications',
		clientResult: 'Résultats clients',
		solution: 'Solution',
		services: 'Services',
		project: 'Projet',
		industry: 'Secteur d\'activité',
		clientLocation: 'Emplacements du client couverts',
		confidentialMessage: '* À des fins internes uniquement. Veuillez ne pas partager les informations du client en dehors de l\'organisation.',
		deliveryLocation: 'Lieux de livraison du projet',
		year: 'Année',
		month: 'Mois',
		years: 'Années',
		and: 'et',
		months: 'Mois',
	},
	[LANGUAGE.it.short]: {
		toolsAndSystems: `Strumenti/Sistemi`,
		certifications: 'Certificazioni',
		clientResult: 'Risultati del cliente',
		solution: 'Soluzione',
		services: 'Servizi',
		project: 'Progetto',
		industry: 'Settore',
		clientLocation: 'Sedi del cliente coperte',
		confidentialMessage: '* Solo per scopi interni. Si prega di non condividere le informazioni del cliente all\'esterno dell\'organizzazione.',
		deliveryLocation: 'Sedi di consegna del progetto.',
		year: 'anno',
		month: 'mese',
		years: 'Anni',
		and: 'e',
		months: 'Mesi',
	},
	[LANGUAGE.ja.short]: {
		toolsAndSystems: `ツール/システム`,
		certifications: '認証',
		clientResult: 'クライアントの結果',
		solution: 'ソリューション',
		services: 'サービス',
		project: 'プロジェクト',
		industry: '業界',
		clientLocation: 'クライアントの所在地',
		confidentialMessage: '* 社内専用です。クライアントの情報を組織外に共有しないでください。',
		deliveryLocation: 'プロジェクト実施場所',
		year: '年',
		month: '月',
		years: '年',
		and: 'および',
		months: '月',
	},
	[LANGUAGE.es.short]: {
		toolsAndSystems: `Herramientas/Sistemas`,
		certifications: 'Certificaciones',
		clientResult: 'Resultados del cliente',
		solution: 'Solución',
		services: 'Servicios',
		project: 'Proyecto',
		industry: 'Industria',
		clientLocation: 'Ubicaciones del cliente cubiertas',
		confidentialMessage: '* Solo para uso interno. No comparta la información del cliente fuera de la organización.',
		deliveryLocation: 'Ubicaciones de entrega del proyecto',
		year: 'año',
		month: 'mes',
		years: 'años',
		and: 'y',
		months: 'meses',
	}
}

